module.exports = __webpack_public_path__ + "img/سازمان.4fb31722.jpg";